<template>
    <div class="card rounded-3 border-0 h-100" @click="$router.push({name: 'news-view', params: {slug: news.slug}})">
      <div class="card-hover rounded-3 h-100">
        <div class="card-img-top" :style="{background: `linear-gradient(to top, #225b7660, rgba(0,0,0,0.0)), url(${news.primaryImage.url}) center / cover no-repeat`}">
          <div class="date">{{formattedDate}}</div>
        </div>
        <div class="card-body d-flex flex-column justify-content-between">
            <div>
              <h5 class="card-title">{{ news.title }}</h5>
              <p class="card-text">{{ news.summary }}</p>
            </div>
            <div class="read-more pt-2">
              {{ $t('read-more') }}
              <i class="fa-solid fa-arrow-right"></i>
            </div>
        </div>
      </div>
    </div>
</template>
<script>
import moment from 'moment'
export default {
  props: {
    news: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    formattedDate () {
      return moment(this.news.date).format('YYYY-MM-DD')
    }
  }
}
</script>
<style lang="scss" scoped>
.card{
  cursor: pointer;
  width: 300px;
  max-width: 80vw;
  padding: 0;
  border-radius: 20px;
  box-shadow: none;
  .card-hover{
    transition: 0.2s ease-in-out;
    box-shadow: 0 0 10px 8px rgba(0,0,0,0.04);
    &:hover{
      transform: scale(1.03);
      box-shadow: 0 0 15px 10px rgba(0,0,0,0.05);
      .read-more{
        color: var(--bs-primary);
      }

    }
    .card-text{
      font-weight: 500;
    }
    .card-img-top{
      width: 100%;
      height: 200px;
      border-radius: var(--bs-border-radius-lg) var(--bs-border-radius-lg) 0 0;
      .date{
        padding: 8px;
        background: #3d769fd0;
        border-radius: var(--bs-border-radius-lg)  0 var(--bs-border-radius-lg) 0;
        color: white;
        width: fit-content;
        font-weight: 600;
        font-size: 13px;
      }
    }
    .card-body{
      height: calc(100% - 200px);
      .card-title{
        font-weight: 700;
      }
      .read-more{
        font-size: 14px;
        font-weight: 600;
        i{
          font-size: 12px;
        }
      }
    }
  }
  @media(max-width:576px) {
    width: 240px;
    text-align: center;
    .card-img-top{
      height: 160px;
      .date{
        font-size: 10px;
      }
    }
    .card-body{
      height: calc(100% - 160px);
      .card-title{
        font-size: 16px;
      }
      .read-more{
        font-size: 14px;
        i{
          font-size: 10px;
        }
      }
    }
  }

}
</style>
